




































































































































































import Vue from 'vue';
import axios from 'axios';
import { mapState, mapActions } from 'vuex';
import { registerLog } from '@/services/hub/logsAction';
import jwtDecode from 'jwt-decode';
import {
  HubIcon,
  HubCard,
  HubMenu,
  HubModal,
  HubButton,
  HubInput,
  HubLoading,
} from '../HubComponents';

export default Vue.extend({
  name: 'NewEventSlat' as string,
  components: {
    HubIcon,
    HubCard,
    HubModal,
    HubMenu,
    HubInput,
    HubButton,
    HubLoading,
  },
  filters: {
    formatDuration(od: { time?: string }) {
      return od?.time ? od.time.split('.')[0] : '-';
    },
  },
  props: {
    secret: {
      type: String,
      required: true,
    },
    event: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedItem: '',
      renamedEvent: this.event.title,
      downloadURL: '',
      modal: false,
      modalDownload: false,
      items: [
        { title: 'rename' },
        { title: 'delete' },
        { title: 'download' },
      ],
      id_customer: 0,
      username: '',
      customerPlansId: 0,
      userToken: '',
    };
  },
  computed: {
    ...mapState(['user']),
    lg(): boolean {
      return this.$vuetify.breakpoint.width <= 1060;
    },
    downloadBtnEnabled(): boolean {
      return !!(
        this.event
        && this.event.status === 'ON_DEMAND'
        && this.event.video_hash
      );
    },
    downloadLinkLoading(): boolean {
      return !this.downloadURL;
    },
  },
  async mounted() {
    await this.userInformation();
  },
  methods: {
    ...mapActions('events', {
      remove: 'remove',
      rename: 'edit',
      download: 'download',
    }),
    async userInformation() {
      const userInfo = localStorage.getItem('user') as any;
      const user = JSON.parse(userInfo);

      const { token } = user;
      const decodedToken = jwtDecode(token) as any;
      this.username = decodedToken.sub.nickname;
      this.id_customer = decodedToken.sub.id_customers;
      this.customerPlansId = user.user.plan_id;
      this.userToken = user.token;
    },
    async logUserAction(action: string, status: string, description: string) {
      try {
        const logData = {
          id_customers: this.id_customer,
          username: this.username,
          action,
          status,
          description,
        };

        await registerLog(logData);
        console.log('Log registrado com sucesso!');
      } catch (error) {
        console.error('Erro ao registrar o log:', error);
      }
    },
    formatSchedule(date: string): string {
      const formatDate = new Intl
        .DateTimeFormat(this.user.settings.lang, {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
        })
        .format(new Date(date));
      return `${formatDate} hs`;
    },
    formatStatus(status: string) {
      switch (status) {
        case 'WAITING_LIVE':
          return this.$t('scheduled');
        case 'ON_DEMAND':
          return this.$t('finished');
        default: // LIVE
          return this.$t('live');
      }
    },
    modalController(title: string): void {
      if (['rename', 'delete'].includes(title)) {
        this.selectedItem = title;
        this.modal = true;
        return;
      }

      this.selectedItem = 'download';
      this.modalDownload = this.downloadBtnEnabled;
      if (this.modalDownload) this.getDownloadURL();
    },
    async modalAction() {
      try {
        if (this.selectedItem === 'rename') {
          try {
            await this.rename({
              title: this.renamedEvent,
              eventId: this.event.id,
              secret: this.secret,
              hash: this.event.event_hash,
            });
            const description = `Renomeou o evento com Hash: ${this.event.event_hash} para ${this.renamedEvent}`;
            await this.logUserAction('Modification', 'Success', description);
          } catch (error) {
            const description = `Erro ao renomear o evento com Hash: ${this.event.event_hash}`;
            await this.logUserAction('Modification', 'Failure', description);
            console.error('Erro ao renomear:', error);
          }
          this.modal = false;
        } else if (this.selectedItem === 'delete') {
          try {
            await this.remove([this.event.id]);
            const description = `Deletou o evento com Hash: ${this.event.event_hash} e título: ${this.event.title}`;
            await this.logUserAction('Deletion', 'Success', description);
          } catch (error) {
            const description = `Erro ao deletar o evento com Hash: ${this.event.event_hash}`;
            await this.logUserAction('Deletion', 'Failure', description);
            console.error('Erro ao deletar:', error);
          }

          this.$emit('reload');
          this.modal = false;
        } else if (this.selectedItem === 'download') {
          if (this.downloadURL) {
            try {
              window.open(this.downloadURL, '_blank');
            } catch (error) {
              console.error('Erro ao baixar:', error);
            }
          }
        }
      } catch (error) {
        console.error('Erro geral no modalAction:', error);
      }
    },
    async getDownloadURL() {
      // console.log('FUI CHAMADO ', Date.now());
      const res = await this.download({ hash: this.event.video_hash });

      const url = res?.data?.data?.url;
      if (url) this.downloadURL = url;
      if (
        this.selectedItem === 'download'
        && this.modalDownload
        && !url
      ) {
        setTimeout(this.getDownloadURL, 2000);
      }
    },
  },
});
